import Api from 'App/api'

export const sendFeedback = Api.post({
  controller: 'feedback',
  action: 'sendFeedback',
})
